<template>
    <div
        style="width: 100%;"
    >
        <v-card
            class="rounded-xl"
        >

            <div
                class="d-flex flex-row pa-4"
            >

                <v-card-title>
                    Resource Presets
                </v-card-title>

                <v-spacer />

                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="blue"
                            v-bind="attrs"
                            dark
                            x-small
                            fab
                            class="mx-4 my-0 mt-2"
                            v-on="on"
                            @click="$emit('open-add-resource')"
                        >
                            <v-icon v-on="on">
                            $vuetify.icons.icon_mdi_plus
                            </v-icon>
                        </v-btn>
                    </template>

                    <span>Add a Resource</span>
                </v-tooltip>
            </div>

            <div
                v-if="resourcesPresets"
                class="d-flex flex-row flex-wrap"
            >
                <v-card
                    v-for="resource in resourcesPresets"
                    :key="resource.id ?? resource._tempId"
                    flat
                    class="d-flex flex-row flex-wrap ma-2 pa-0 rounded-xl"
                    color="blue"
                    min-width="350px"
                    min-height="50px"
                    width="20%"
                >
                    <div
                        class="d-flex flex-column justify-space-between"
                        style="width: 100%;"
                    >
                        <v-card-text>
                            <h4>
                            {{ resource.typeName }} #{{ resource.number_type }}
                            </h4>

                            <div v-if="resource.type_id === 1 || resource.type_id === 2">
                            <div>
                                Category:
                                <span v-if="resource.category_id">
                                {{ getProjectCategory(resource.category_id) }}
                                </span>
                                <span v-else>
                                to be selected
                                </span>
                            </div>

                            <div>
                                Project:
                                <span v-if="resource.project_id">
                                {{ getProjectName(resource.project_id) }}
                                </span>
                                <span v-else>
                                to be selected
                                </span>
                            </div>
                            </div>

                            <div v-if="resource.type_id === 3 || resource.type_id === 8">
                            <div>
                                Language: {{ resource.class_language }}
                            </div>

                            <div>
                                Type: {{ resource.class_group }} - {{ resource.class_type }}
                            </div>

                            <div>
                                Duration: {{ resource.hours }} hours
                            </div>

                            <div>
                                {{ resource.hours_per_class }} hours per class
                            </div>
                            </div>

                            <div v-if="resource.type_id === 4">
                            <div>
                                Type:
                                <span v-if="resource.family == 0">
                                Apartment
                                </span>
                                <span v-else>
                                Family
                                </span>
                            </div>

                            <div>
                                Class:
                                <span v-if="resource.accommodation_class">
                                {{ resource.accommodation_class }}
                                </span>
                                <span v-else>
                                to be selected
                                </span>
                            </div>
                            </div>

                            <div v-if="resource.type_id === 5">
                            <div>
                                Tour:
                                <span v-if="resource.tour_id">
                                {{ getTour(resource.tour_id).name }}
                                </span>
                                <span v-else>
                                to be selected
                                </span>
                            </div>
                            </div>

                            <div>
                            <span v-if="resource.comments">
                                Comments: {{ resource.comments }}
                            </span>
                            <span v-else>
                                No comments
                            </span>
                            </div>

                            <v-btn
                                class="my-4 py-4 rounded-xl white--text"
                                small
                                color="blue lighten-2"
                                width="99%"
                                :disabled="$store.state.loadingApp > 0"
                                @click="$emit('edit-resource', resource)"
                            >
                            <v-icon left>
                                $vuetify.icons.icon_mdi_pencil
                            </v-icon>
                            Edit the Resource
                            </v-btn>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer />

                            <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                x-small
                                class="ma-2"
                                fab
                                color="blue lighten-2"
                                :disabled="$store.state.loadingApp > 0"
                                @click="$emit('delete-resource', resource.id)"
                                >
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    $vuetify.icons.icon_mdi_delete
                                </v-icon>
                                </v-btn>
                            </template>

                            <span>Remove the Resource</span>
                            </v-tooltip>
                        </v-card-actions>
                    </div>
                </v-card>
            </div>
        </v-card>

        <v-dialog
            :value="dialogAddResource"
            :retain-focus="false"
            max-width="320px"
            @input="$emit('update-dialog-add-resource', $event)"
        >
            <v-form ref="dialogForm">
                <v-card>
                <v-card-title class="blue">
                    <span class="headline white--text">Add Resource</span>
                </v-card-title>

                <v-card-text>
                    <v-list-item-group
                    color="primary"
                    >
                    <v-list-item
                        v-for="(resource, i) in resourceTypes"
                        :key="i"
                        @click="$emit('add-resource', resource.type_id)"
                    >
                        <v-list-item-icon>
                        <v-icon v-text="resource.icon" />
                        </v-list-item-icon>

                        <v-list-item-content>
                        <v-list-item-title v-text="resource.text" />
                        </v-list-item-content>
                    </v-list-item>
                    </v-list-item-group>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />

                    <v-btn
                    color="blue"
                    text
                    @click="$emit('update-dialog-add-resource', false)"
                    >
                    Done
                    </v-btn>
                </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog
            :value="dialogResource"
            max-width="500px"
            @input="$emit('save-resource', $event)"
        >
            <v-card
                class="d-flex flex-column pa-2"
                color="blue"
                rounded="xl"
            >
                <div v-if="updatedResourcePreset.type_id === 1 || updatedResourcePreset.type_id === 2">
                <v-card-title>
                    <span
                    v-if="updatedResourcePreset.type_id === 1"
                    class=" white--text"
                    >Volunteer Placement #{{ updatedResourcePreset.number_type }}</span>
                    <span
                    v-if="updatedResourcePreset.type_id === 2"
                    class=" white--text"
                    >Internship Placement #{{ updatedResourcePreset.number_type }}</span>
                </v-card-title>
                <v-card-text>
                    <v-select
                        v-model="updatedResourcePreset.category_id"
                        :items="categoriesProjects(updatedResourcePreset.type_id)"
                        item-text="category"
                        item-value="category_id"
                        :menu-props="{ auto: true }"
                        label="Category"
                        validate-on-blur
                        clearable
                        color="white"
                        item-color="blue"
                        :disabled="updatedResourcePreset.placement_id !== null"
                        @click:clear="updatedResourcePreset.project_id = null, updatedResourcePreset.placement_id = null, updatedResourcePreset.payment = null, updatedResourcePreset.donation = null, updatedResourcePreset.donation_type = null"
                        @change="updatedResourcePreset.project_id = null, updatedResourcePreset.placement_id = null, updatedResourcePreset.payment = null, updatedResourcePreset.donation = null, updatedResourcePreset.donation_type = null"
                    >
                    <template #selection="{ item }">
                        <span class="white--text">{{ item.category }}</span>
                    </template>
                    </v-select>
                    <v-select
                    v-model="updatedResourcePreset.project_id"
                    :items="filterProjects(updatedResourcePreset.type_id, updatedResourcePreset.category_id, updatedResourcePreset.project_id)"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Project"
                    validate-on-blur
                    clearable
                    color="white"
                    item-color="blue"
                    :disabled="updatedResourcePreset.placement_id !== null"
                    @click:clear="updatedResourcePreset.project_id = null, updatedResourcePreset.placement_id = null, updatedResourcePreset.payment = null, updatedResourcePreset.donation = null, updatedResourcePreset.donation_type = null"
                    @change="updatedResourcePreset.placement_id = null, updatedResourcePreset.payment = null, updatedResourcePreset.donation = null, updatedResourcePreset.donation_type = null, updatedResourcePreset.category_id = filterProjects(updatedResourcePreset.type_id, 
                                                                                                                                                                                                                                                    updatedResourcePreset.category_id, updatedResourcePreset.project_id)[0].category_id"
                    >
                    <template #selection="{ item }">
                        <span class="white--text">{{ item.name }}</span>
                    </template>
                    </v-select>
                </v-card-text>
                </div>

                <div v-if="updatedResourcePreset.type_id === 3 || updatedResourcePreset.type_id === 8">
                <v-card-title>
                    <span class="white--text">Language Course #{{ updatedResourcePreset.number_type }}</span>
                </v-card-title>
                <v-card-text>
                    <div class="d-flex flex-row flex-wrap">
                    <div class="d-flex flex-row flex-wrap">
                        <v-radio-group
                        v-model="updatedResourcePreset.class_language"
                        cols="12"
                        column
                        class="mt-0 mr-6"
                        :disabled="updatedResourcePreset.minutes_planned > 0"
                        >
                        <v-radio
                            label="Spanish"
                            value="Spanish"
                            class="my-0 py-0"
                            color="white"
                        />
                        <v-radio
                            label="Quechua"
                            value="Quechua"
                            class="my-0 py-0"
                            color="white"
                        />
                        <v-radio
                            label="English"
                            value="English"
                            class="my-0 py-0"
                            color="white"
                        />
                        </v-radio-group>
                        <v-radio-group
                        v-model="updatedResourcePreset.class_location"
                        cols="12"
                        column
                        class="mt-0 mr-6"
                        :disabled="updatedResourcePreset.minutes_planned > 0"
                        >
                        <v-radio
                            label="Cusco School"
                            value="School Cusco"
                            class="my-0 py-0"
                            color="white"
                        />
                        <v-radio
                            label="Urubamba"
                            value="Urubamba"
                            class="my-0 py-0"
                            color="white"
                        />
                        <v-radio
                            label="Online"
                            value="Online"
                            class="my-0 py-0"
                            color="white"
                        />
                        </v-radio-group>
                    </div>
                    <div class="d-flex flex-row flex-wrap">
                        <v-radio-group
                        v-model="updatedResourcePreset.class_type"
                        cols="12"
                        column
                        class="mt-0 mr-6"
                        :disabled="updatedResourcePreset.minutes_planned > 0"
                        >
                        <v-radio
                            label="Normal"
                            value="Normal"
                            class="my-0 py-0"
                            color="white"
                        />
                        <v-radio
                            label="Specialism"
                            value="Special"
                            class="my-0 py-0"
                            color="white"
                        />
                        </v-radio-group>
                        <v-radio-group
                        v-model="updatedResourcePreset.class_group"
                        cols="12"
                        column
                        class="mt-0 mr-6"
                        :disabled="updatedResourcePreset.minutes_planned > 0"
                        >
                        <v-radio
                            label="Group"
                            value="Group"
                            class="my-0 py-0"
                            color="white"
                        />
                        <v-radio
                            label="Individual"
                            value="Individual"
                            class="my-0 py-0"
                            color="white"
                        />
                        </v-radio-group>
                    </div>
                    </div>
                    <v-card-text>
                    <v-text-field
                        v-model="updatedResourcePreset.hours"
                        label="Hours sold"
                        class="text-input-white"
                        color="white"
                    />
                    <v-text-field
                        v-model="updatedResourcePreset.hours_per_class"
                        label="Hours per class"
                        class="text-input-white"
                        color="white"
                    />
                    </v-card-text>
                </v-card-text>
                </div>

                <div v-if="updatedResourcePreset.type_id === 4">
                <v-card-title>
                    <span class=" white--text">Accommodation #{{ updatedResourcePreset.number_type }}</span> 
                </v-card-title>
                <v-card-text>
                    <div class="d-flex flex-row flex-wrap justify-space-between">
                    <v-radio-group
                        v-model="updatedResourcePreset.family"
                        cols="12"
                        column
                        class="mt-0"
                        :disabled="updatedResourcePreset.room_id !== null"
                        @change="updatedResourcePreset.private_bathroom = 0"
                    >
                        <v-radio
                        label="Family"
                        value="1"
                        class="my-0 py-0"
                        color="white"
                        />
                        <v-radio
                        label="Apartment"
                        value="0"
                        class="my-0 py-0"
                        color="white"
                        />
                    </v-radio-group>
                    <v-radio-group
                        v-model="updatedResourcePreset.accommodation_class"
                        cols="12"
                        column
                        class="mt-0"
                        :disabled="updatedResourcePreset.room_id !== null"
                        @change="updatedResourcePreset.private_bathroom = 0"
                    >
                        <v-radio
                        label="Private Room"
                        value="Private Room"
                        class="my-0 py-0"
                        color="white"
                        />
                        <v-radio
                        label="Private Double"
                        value="Private Double"
                        class="my-0 py-0"
                        color="white"
                        />
                        <v-radio
                        label="Private Twin"
                        value="Private Twin"
                        class="my-0 py-0"
                        color="white"
                        />
                        <v-radio
                        label="Shared Room"
                        value="Shared Room"
                        class="my-0 py-0"
                        color="white"
                        />
                        <v-radio
                        label="Shared Bunk"
                        value="Shared Bunk"
                        class="my-0 py-0"
                        :disabled="updatedResourcePreset.family == 1"
                        color="white"
                        />
                    </v-radio-group>
                    <v-checkbox
                        v-model="updatedResourcePreset.private_bathroom"
                        label="Private Bathroom"
                        class="mr-4 mt-0"
                        color="white"
                        :disabled="updatedResourcePreset.room_id !== null || updatedResourcePreset.accommodation_class === 'Shared Room' || updatedResourcePreset.accommodation_class === 'Shared Bunk'"
                    />
                    </div>
                </v-card-text>
                </div>

                <div v-if="updatedResourcePreset.type_id === 5">
                <v-card-title>
                    <span class=" white--text">Tour #{{ updatedResourcePreset.number_type }}</span>
                </v-card-title>
                <v-card-text>
                    <v-select
                    v-model="updatedResourcePreset.tour_id"
                    :items="tourSelect"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Tour"
                    validate-on-blur
                    clearable
                    color="white"
                    item-color="blue"
                    :disabled="updatedResourcePreset.tour_placement_id !== null"
                    >
                    <template #selection="{ item }">
                        <span class="white--text">{{ item.name }}</span>
                    </template>
                    </v-select>
                </v-card-text>
                </div>

                <v-card-text>
                <v-textarea
                    v-model="updatedResourcePreset.comments"
                    class="rounded-xl px-6"
                    auto-grow
                    clearable
                    counter="255"
                    outlined
                    label="Comments (255 max)"
                    :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                    color="white"
                />
                </v-card-text>
                
                <v-card-actions
                    class="d-flex flex-row flex-wrap justify-space-between"
                    color="blue lighten-2"
                    style="width: 100%"
                >
                #{{ updatedResourcePreset.id }}
                <v-spacer />
                <v-btn
                    color="white"
                    text
                    @click="$emit('cancel-resource')"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="white" 
                    text
                    @click="$emit('save-resource')"
                >
                    Done
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
    </div>
</template>

<script>
export default {
  name: 'ServiceResourcePresets',

  props: {
    resourcesPresets: {
      type: Array,
      default: () => [],
    },

    updatedResourcePreset: {
      type: Object,
      default: () => ({}),
    },

    getProjectCategory: {
      type: Function,
      required: true,
    },

    getProjectName: {
      type: Function,
      required: true,
    },

    getTour: {
      type: Function,
      required: true,
    },

    dialogAddResource: {
        type: Boolean,
        default: false,
    },

    dialogResource: {
        type: Boolean,
        default: false,
    },

    resourceTypes: {
        type: Array,
        default: () => [],
    },

    categoriesProjects: {
        type: Function,
        required: true
    },

    filterProjects: {
        type: Function,
        required: true
    },

    tourSelect: {
        type: Array,
        default: () => [],
    },
  },

}
</script>